var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("MonthPickerDialog", {
        attrs: { viewModel: _vm.startDateBoundaryMonthPicker },
        on: {
          "update-date": function ($event) {
            _vm.startDateBoundary = $event
          },
        },
      }),
      _vm._v(" "),
      _c("MonthPickerDialog", {
        attrs: { viewModel: _vm.endDateBoundaryMonthPicker },
        on: {
          "update-date": function ($event) {
            _vm.endDateBoundary = $event
          },
        },
      }),
      _vm._v(" "),
      _c("MonthPickerDialog", {
        attrs: { viewModel: _vm.defaultProjectStartDateMonthPicker },
        on: {
          "update-date": function ($event) {
            _vm.defaultProjectStartDate = $event
          },
        },
      }),
      _vm._v(" "),
      _c("CorporateNavigation", { attrs: { ActivePage: "metrics" } }),
      _vm._v(" "),
      _vm.initialized
        ? _c(
            "div",
            {
              staticClass: "container",
              staticStyle: { "margin-top": "80px", "padding-top": "40px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _c("h6", [
                    _c(
                      "a",
                      {
                        staticClass: "text-dark",
                        on: { click: _vm.handleBack },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-angle-double-left",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" Back\n                    "),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "h1",
                    {
                      staticStyle: {
                        "font-size": "2em",
                        "font-weight": "300",
                        color: "#33475b",
                        margin: "0",
                      },
                    },
                    [_vm._v(_vm._s(_vm.pageHeading))]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6 text-right align-self-end" },
                  [
                    _c(
                      "button",
                      {
                        class: _vm.hasChanges
                          ? "btn btn-warning"
                          : "btn btn-outline-secondary",
                        staticStyle: { padding: "0.7em 2em" },
                        attrs: {
                          type: "submit",
                          form: "metric-configuration-form",
                          disabled: _vm.isSaving,
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.saveButtonText) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.hasChanges
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-secondary",
                            staticStyle: { padding: "0.7em 2em" },
                            attrs: { type: "button" },
                            on: { click: _vm.handleCancel },
                          },
                          [
                            _vm._v(
                              "\n                    Cancel\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("hr", { staticClass: "mb-5" }),
              _vm._v(" "),
              _c(
                "form",
                {
                  staticClass: "mb-4",
                  attrs: { id: "metric-configuration-form" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.handleSave.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "form-group mb-4" }, [
                    _c("label", [_vm._v("Metric Name:")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.name,
                          expression: "name",
                          modifiers: { trim: true },
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        required: "",
                        maxlength: "100",
                        minlength: "2",
                      },
                      domProps: { value: _vm.name },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.name = $event.target.value.trim()
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "error" }, [
                      _vm._v(_vm._s(_vm.nameError)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group mb-4" }, [
                    _c("label", [_vm._v("Metric Description:")]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.description,
                          expression: "description",
                          modifiers: { trim: true },
                        },
                      ],
                      staticClass: "form-control",
                      domProps: { value: _vm.description },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.description = $event.target.value.trim()
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-row" }, [
                    _c("div", { staticClass: "form-group mb-4 col" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form-label",
                          attrs: { for: "revenue" },
                        },
                        [_vm._v("Measured Expense:")]
                      ),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.expenseAccountId,
                              expression: "expenseAccountId",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { id: "revenue" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.expenseAccountId = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v("Total Expense"),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.rm.Expenses, function (r) {
                            return _c(
                              "option",
                              { key: r.Id, domProps: { value: r.Id } },
                              [_vm._v(_vm._s(r.Name))]
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group mb-4 col" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form-label",
                          attrs: { for: "valueBalanceType" },
                        },
                        [_vm._v("Data Type:")]
                      ),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.valueBalanceType,
                              expression: "valueBalanceType",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { id: "valueBalanceType" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.valueBalanceType = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "Costs" } }, [
                            _vm._v("Costs"),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "Benefits" } }, [
                            _vm._v("Savings"),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "Net" } }, [
                            _vm._v("Balance (Costs - Savings)"),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group mb-4" }, [
                    _c("label", { attrs: { for: "denomination" } }, [
                      _vm._v("Currency denomination:"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.denomination,
                            expression: "denomination",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { id: "denomination" },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.denomination = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "Unit" } }, [
                          _vm._v("Unit"),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "Thousand" } }, [
                          _vm._v("Thousand"),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "Million" } }, [
                          _vm._v("Million"),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("fieldset", { staticClass: "border p-3 mt-4" }, [
                    _c("legend", { staticClass: "w-auto px-2 text-primary" }, [
                      _vm._v("Schedule-dependent Settings"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group mb-4" }, [
                      _c("div", { staticClass: "form-check" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.isScheduleDependent,
                              expression: "isScheduleDependent",
                            },
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            type: "checkbox",
                            id: "toggleAdvancedSettings",
                          },
                          domProps: {
                            checked: Array.isArray(_vm.isScheduleDependent)
                              ? _vm._i(_vm.isScheduleDependent, null) > -1
                              : _vm.isScheduleDependent,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.isScheduleDependent,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.isScheduleDependent = $$a.concat([
                                      $$v,
                                    ]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.isScheduleDependent = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.isScheduleDependent = $$c
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label",
                            attrs: { for: "toggleAdvancedSettings" },
                          },
                          [
                            _vm._v(
                              "\n                            Enable schedule-dependent settings to configure time-sensitive and commitment-based metric adjustments.\n                        "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.isScheduleDependent
                      ? _c("div", [
                          _c("div", { staticClass: "form-group mb-4" }, [
                            _c(
                              "label",
                              {
                                staticClass: "form-label",
                                attrs: { for: "startDate" },
                              },
                              [_vm._v("Default Project Start Date:")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-group" }, [
                              _c("input", {
                                staticClass: "form-control pointer bg-white",
                                attrs: {
                                  type: "text",
                                  placeholder: "Optional...",
                                  readonly: "",
                                },
                                domProps: {
                                  value: _vm.defaultProjectStartDateLabel,
                                },
                                on: {
                                  click:
                                    _vm.showDefaultProjectStartDateMonthPicker,
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "input-group-append" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-outline-secondary",
                                    attrs: { type: "button" },
                                    on: {
                                      click:
                                        _vm.showDefaultProjectStartDateMonthPicker,
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-regular fa-calendar",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _vm._m(0),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-row" }, [
                            _c("div", { staticClass: "form-group mb-4 col" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "form-label",
                                  attrs: { for: "startDateBoundary" },
                                },
                                [_vm._v("Metric Start Date Boundary:")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  staticClass: "form-control pointer bg-white",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Optional...",
                                    readonly: "",
                                  },
                                  domProps: {
                                    value: _vm.startDateBoundaryLabel,
                                  },
                                  on: {
                                    click: _vm.showStartDateBoundaryMonthPicker,
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "input-group-append" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-outline-secondary",
                                        attrs: { type: "button" },
                                        on: {
                                          click:
                                            _vm.showStartDateBoundaryMonthPicker,
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa-regular fa-calendar",
                                          attrs: { "aria-hidden": "true" },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "small",
                                { staticClass: "form-text text-muted" },
                                [
                                  _vm._v(
                                    "\n                                Includes only values after this date in calculations. If not set, values start from the project’s start date.\n                            "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group mb-4 col" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "form-label",
                                  attrs: { for: "endDateBoundary" },
                                },
                                [_vm._v("Metric End Date Boundary:")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  staticClass: "form-control pointer bg-white",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Optional...",
                                    readonly: "",
                                  },
                                  domProps: { value: _vm.endDateBoundaryLabel },
                                  on: {
                                    click: _vm.showEndDateBoundaryMonthPicker,
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "input-group-append" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-outline-secondary",
                                        attrs: { type: "button" },
                                        on: {
                                          click:
                                            _vm.showEndDateBoundaryMonthPicker,
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa-regular fa-calendar",
                                          attrs: { "aria-hidden": "true" },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "small",
                                { staticClass: "form-text text-muted" },
                                [
                                  _vm._v(
                                    "\n                                Includes only values before this date in calculations. If not set, values include all up to the project’s end date.\n                            "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-row" }, [
                            _c("div", { staticClass: "form-group mb-4 col" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "form-label",
                                  attrs: {
                                    for: "applyBenefitsConfidenceFactor",
                                  },
                                },
                                [_vm._v("Risk Adjustment:")]
                              ),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.applyBenefitsConfidenceFactor,
                                      expression:
                                        "applyBenefitsConfidenceFactor",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    id: "applyBenefitsConfidenceFactor",
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.applyBenefitsConfidenceFactor = $event
                                        .target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c("option", { domProps: { value: false } }, [
                                    _vm._v("Disabled"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { domProps: { value: true } }, [
                                    _vm._v("Enabled"),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "small",
                                { staticClass: "form-text text-muted" },
                                [
                                  _vm._v(
                                    "\n                                Applies a risk factor to adjust the metric value after the Benefits Confidence Date set at the portfolio level.\n                                This setting is applicable only if the value source includes savings (benefits).\n                            "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group mb-4 col" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "form-label",
                                  attrs: { for: "valueCommitmentType" },
                                },
                                [_vm._v("Commitment Adjustment:")]
                              ),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.valueCommitmentType,
                                      expression: "valueCommitmentType",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { id: "valueCommitmentType" },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.valueCommitmentType = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "Total" } }, [
                                    _vm._v("Disabled"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "Committed" } },
                                    [_vm._v("Committed")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "Tentative" } },
                                    [_vm._v("Tentative")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._m(1),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("small", { staticClass: "form-text text-muted" }, [
      _vm._v(
        "\n                            Used as the default start date for projects without one. Enables schedule-dependent calculations for unscheduled projects.\n                            "
      ),
      _c("strong", [
        _vm._v(
          "If neither a set nor default start date is provided, schedule-dependent metrics will have no value."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("small", { staticClass: "form-text text-muted" }, [
      _vm._v(
        "\n                                Adjusts the metric value based on the project commitment date:\n                                "
      ),
      _c("strong", [_vm._v("Committed:")]),
      _vm._v(
        " Includes values before the commitment date, reflecting firmly committed resources.\n                                "
      ),
      _c("strong", [_vm._v("Tentative:")]),
      _vm._v(
        " Includes values after the commitment date, reflecting flexible or changeable plans.\n                                "
      ),
      _c("strong", [_vm._v("Disabled:")]),
      _vm._v(
        " Ignores the commitment date, including all values.\n                                "
      ),
      _c("strong", [_vm._v("Note:")]),
      _vm._v(
        " If no commitment date is set, all resources are considered tentative.\n                            "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }